export type GameplanAffordability =
  | {
      creditCost: number;
      creditShortfall: number;
      state: 'insufficientCredits';
    }
  | { creditCost: number; creditShortfall?: undefined; state: 'affordable' }
  | { creditCost: number; creditShortfall?: undefined; state: 'free' }
  | { creditCost?: undefined; creditShortfall?: undefined; state: 'hiddenPrice' };

export const calculateGameplanAffordability = (
  creditCost: number | null | undefined,
  availableCredits: number,
): GameplanAffordability => {
  if (creditCost === undefined || creditCost === null) {
    return { state: 'hiddenPrice' };
  }

  if (creditCost <= 0) {
    return { creditCost: 0, state: 'free' };
  }

  const shortfall = Math.max(0, creditCost - availableCredits);

  if (shortfall === 0) {
    return { creditCost, state: 'affordable' };
  }

  return { creditCost, creditShortfall: shortfall, state: 'insufficientCredits' };
};
